import { render } from "./DatosDerecho.vue?vue&type=template&id=2743bee3&scoped=true"
import script from "./DatosDerecho.vue?vue&type=script&lang=js"
export * from "./DatosDerecho.vue?vue&type=script&lang=js"

import "./DatosDerecho.vue?vue&type=style&index=0&id=2743bee3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2743bee3"]])

export default __exports__